import type { TCustomerData } from 'shared/types/TCustomerService';
import type { TFullData } from 'shared/types/TUserAddressFields';

export const convertAddressField = (value: unknown): Nullable<Dictionaries.TSelectValue<string, TFullData>> => {
  const addressValue = value as TCustomerData['registrationAddress'];
  const { dadata = '' } = addressValue || {};

  if (!dadata) {
    return null;
  }

  return {
    value: dadata,
    label: dadata,
    data: addressValue
      ? {
          ...addressValue,
          fias_level: addressValue.fias_level ?? undefined,
          region_with_type: addressValue.region_with_type ?? undefined,
          region_fias_id: addressValue.region_fias_id ?? undefined,
          city_with_type: addressValue.city_with_type ?? undefined,
          city_fias_id: addressValue.city_fias_id ?? undefined,
          settlement_with_type: addressValue.settlement_with_type ?? undefined,
          settlement_fias_id: addressValue.settlement_fias_id ?? undefined,
          street_with_type: addressValue.street_with_type ?? undefined,
          street_fias_id: addressValue.street_fias_id ?? undefined,
          house: addressValue.house ?? undefined,
        }
      : undefined,
  };
};
